import { render } from "./musica_fondo_ingles.vue?vue&type=template&id=797c5a95&scoped=true"
import script from "./musica_fondo_ingles.vue?vue&type=script&lang=js"
export * from "./musica_fondo_ingles.vue?vue&type=script&lang=js"

import "./musica_fondo_ingles.vue?vue&type=style&index=0&id=797c5a95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797c5a95"]])

export default __exports__